import React from 'react';

import { LightDiskBadge } from '../../common/fromAuth/LightDiskBadge/LightDiskBadge';
import { LightPanel } from '../../common/fromAuth/LightPanel/LightPanel';

const PromoCountryLetterItem = (props) => {
    return (
        <LightPanel negativeMargin>
            <LightDiskBadge variant="letterIndex" diskText={props.letter} />
        </LightPanel>
    );
};

export default PromoCountryLetterItem;
